import { generatePaperViewHref, generatePatentViewHref, generateReportViewHref, generateProjectViewHref, generatePaperPumViewHref, generatePatentPumViewHref } from '@eureka/utils/view';
import type { ISolution } from '../types';
import { SOLUTION_TYPE } from '../types';

export function normalizeSolutionOrgInfo(solution: ISolution) {
    if (solution?.SOLUTION_TYPE === SOLUTION_TYPE.PATENT) {
        return solution
    }
    const orgs = solution.ORG_INFO?.map(org => ({
        display_name: org.normalized_display_name,
        id: org.normalized_id,
        logo: org.normalized_logo,
    }));
    return {
        ...solution,
        ORG_INFO: orgs,
    }
}

export function getSolutionLink(solution: ISolution, trackData?: Record<string, string>) {
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PATENT) { return generatePatentViewHref({ patentId: solution.SOLUTION_ID, params: trackData }) }
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PAPER) { return generatePaperViewHref({ solutionId: solution.SOLUTION_ID, params: trackData }) }
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.REPORT) { return generateReportViewHref({ reportId: solution.SOLUTION_ID }) }
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PROJECT) { return generateProjectViewHref({ solution }) }
    return solution?.LINK
}

/**
 * Get PUM (Properties, Units, Measurements) view link for a solution
 * @param solution - The solution object
 * @param trackData - Optional tracking data to append to the URL
 * @returns URL to the PUM view, or empty string if solution type is not supported
 */
export function getSolutionPumLink(solution: ISolution, trackData?: Record<string, string>) {
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PATENT) { return generatePatentPumViewHref({ patentId: solution.SOLUTION_ID, params: trackData }) }
    if (solution.SOLUTION_TYPE === SOLUTION_TYPE.PAPER) { return generatePaperPumViewHref({ paperId: solution.SOLUTION_ID, params: trackData }) }
    return ''
}
